import { useSearchParams } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import FullLoading from "../../components/FullLoading";
import { useMutation } from "@apollo/client";
import {
  CurrentUserOrganizationsDocument,
  JoinOrganizationDocument,
} from "../../__generated__/graphql";
import { useEffect } from "react";
import useNav from "../../hooks/useNavigation";

export default function JoinOrganization() {
  const navigateWithLog = useNav();

  const [searchParams] = useSearchParams();
  const invitationCode = searchParams.get("invitationCode");

  const { isAuthenticated, isAuthLoading, logout } = useAuth();

  const [joinOrganization, { loading: joinOrganizationLoading }] = useMutation(
    JoinOrganizationDocument
  );

  useEffect(() => {
    async function handleJoin() {
      if (isAuthenticated && invitationCode) {
        try {
          const { data } = await joinOrganization({
            variables: {
              joinOrganizationInput: {
                invitationCode,
              },
            },
            refetchQueries: [CurrentUserOrganizationsDocument],
          });

          if (data?.joinOrganization?.token) {
            localStorage.setItem("token", data.joinOrganization.token);
          }

          if (data?.joinOrganization?.organization.id) {
            localStorage.setItem(
              "organizationId",
              data.joinOrganization.organization.id
            );
          }

          localStorage.removeItem("invitationCode");
          localStorage.removeItem("invitedToOrganizationId");

          navigateWithLog("/");
        } catch (error) {
          if (
            error instanceof Error &&
            error.message === "Invitation déjà acceptée"
          ) {
            navigateWithLog("/");
          } else {
            logout();
          }
        }
      }
    }

    if (!isAuthLoading && !isAuthenticated) {
      logout();
    }

    if (!joinOrganizationLoading && isAuthenticated) {
      handleJoin();
    }
  }, [
    isAuthenticated,
    invitationCode,
    joinOrganization,
    navigateWithLog,
    isAuthLoading,
    logout,
    joinOrganizationLoading,
  ]);

  return <FullLoading />;
}
